import React from 'react'
interface Prop {
    onClick: () => void;
    label: string;
    className?: string;
    disabled?:boolean;
    prefix?:string;
}
export default function HrButton({ label, onClick, className = "" , disabled=false,prefix="+"}: Prop) {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={` flex justify-center items-center gap-2
    bg-white
    text-customOrange
    text-sm font-medium
    px-5 py-1
    rounded-full
text-[14px]
    shadow-[0_4px_10px_rgba(255,165,0,0.18)]
    transition-all duration-300
h-[32px]
    
    hover:bg-gradient-to-r from-customOrange via-[#fdce7c] to-[#da8c06] 
  bg-[length:200%_200%] animate-[gradient-x_4s_ease_infinite]
    hover:text-white
    hover:shadow-[0_6px_14px_rgba(255,165,0,0.18)]
    border-[#FFA100]
    border-[1px] active:scale-95
    border-opacity-10
    ${disabled ? "cursor-not-allowed opacity-80":""}
    ${className}
    `}
        >
            <span className="text-lg leading-none">{prefix}</span>
            {label}
        </button>
    )
}
